import { openDB } from 'idb';

// Configuración inicial de IndexedDB
const DATABASE_NAME = 'galilea-app';
const STORE_NAME = 'items';
const DATABASE_VERSION = 5;

export class IndexedDBService {

    async initDB() {
        return await openDB(DATABASE_NAME, DATABASE_VERSION, {
            upgrade(db) {
                if (db.objectStoreNames.contains(STORE_NAME)) {
                    db.deleteObjectStore(STORE_NAME);
                }
                db.createObjectStore(STORE_NAME, { keyPath: "id" });
            }
        });
    };

    async destroyDB() {
        const db = await this.initDB();
        db.close();
    };

    async clearStore() {
        try {
            const db = await this.initDB();
            const tx = db.transaction(STORE_NAME, 'readwrite');
            await tx.objectStore(STORE_NAME).clear();
            await tx.done;
            console.log(`El almacén ${STORE_NAME} ha sido limpiado.`);
            return true;
        } catch (error) {
            return error;
        }
    };

    // Agregar un nuevo dato
    async addItem(data) {
        const db = await this.initDB();
        const id = await db.add(STORE_NAME, data);
        return id;
    };

    // Obtener todos los datos
    async getAllItems() {
        const db = await this.initDB();
        const items = await db.getAll(STORE_NAME);
        return items;
    };

    //Obtener item por id
    async getItemById(id) {
        const db = await this.initDB();
        const item = await db.get(STORE_NAME, id);
        return item;
    };

    //Eliminar item
    async deleteItem(id) {
        const db = await this.initDB();
        await db.delete(STORE_NAME, id);
    };

    //actualizar item
    async updateItem(id, updatedData) {
        const db = await this.initDB();
        await db.put(STORE_NAME, { ...updatedData, id });
    };

    async findItem(key, value) {
        const db = await this.initDB();
        const allItems = await db.getAll(STORE_NAME);
        return allItems.find((item) => item[key] === value) || null;
    };

    async setItemByKey(key, value) {
        try {
            const db = await this.initDB();
            const tx = db.transaction(STORE_NAME, "readwrite");

            const safeValue = JSON.parse(JSON.stringify(value));

            await tx.objectStore(STORE_NAME).put({
                id: key,     // <- ESTA ES LA CLAVE REAL DEL STORE
                value: safeValue
            });

            await tx.done;
        } catch (error) {
            console.error("❌ Error al guardar en IndexedDB:", error);
        }
    }


    async getItemByKey(key) {
        const db = await this.initDB();
        return await db.get(STORE_NAME, key);
    }

    async cleanDuplicatesByKey(key) {
        const db = await this.initDB();
        const tx = db.transaction(STORE_NAME, "readwrite");
        const store = tx.objectStore(STORE_NAME);

        const all = await store.getAll();
        const drafts = all.filter((item) => item?.id === key);

        if (drafts.length <= 1) return drafts[0] ?? null;

        drafts.sort((a, b) => b.id - a.id);
        const latest = drafts[0];

        for (let i = 1; i < drafts.length; i++) {
            await store.delete(drafts[i].id);
        }

        await tx.done;
        return latest;
    }
}
